<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter chapter" id="preface002">
<div class="image_full" id="page-vi"><img alt="Book Title Page" src="images/Art_Pvi.jpg"/></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface002.vue?3b19ef6d